import React from "react"
import styles from './Dropdown.module.sass'
import { ReactComponent as Arrow } from "@assets/images/arrow.svg"
import { clsx } from "clsx"
import { MenuItem, ListItemText, MenuItemProps } from "@material-ui/core"

type DropdownProps = React.PropsWithChildren<{
  placeholder: string,
  iconOnly?: boolean,
}>

type PopoverProps = React.PropsWithChildren<{
  elementRef: React.RefObject<HTMLElement> | null,
  className?: string,
  onMouseLeave?: React.MouseEventHandler<HTMLDivElement>
}>

const Popover = ({ elementRef, onMouseLeave, className, children }: PopoverProps) => {
  if (!elementRef?.current) {
    return null;
  }

  const element = elementRef.current
  const bounds = element.getBoundingClientRect()

  return (
    <div
      className={className}
      style={{
        position: "absolute",
        top: bounds.height + 5,
        minWidth: bounds.width,
        zIndex: 1
      }}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  )
}

const Root = ({ placeholder, iconOnly = false, children }: DropdownProps) => {
  const ref = React.useRef<HTMLButtonElement>(null)
  const [open, setOpen] = React.useState<React.RefObject<HTMLElement> | null>(null)

  const handleClick = () => {
    setOpen(state => state ? null : ref);
  }

  const handleMouseOut = () => {
    setOpen(null)
  }

  return (
    <div className={styles.container}>
      <button
        ref={ref}
        className={clsx(styles.button, { [styles.iconOnly]: iconOnly })}
        onClick={handleClick}
      >
        {!iconOnly && <span className={styles.placeholder}>{placeholder}</span>}
        <Arrow className={clsx(styles.arrow, {
          [styles.flipped]: open
        })} />
      </button>
      {/* @ts-ignore */}
      <Popover elementRef={open} className={styles.popover} onMouseLeave={handleMouseOut}>
        {children}
      </Popover>
    </div>
  )
}

type OptionsProps = {
  value: string;
  label: string;
} & MenuItemProps

const Option = ({ value, label, ...passThroughProps }: OptionsProps) => {
  return (
    <MenuItem value={value} {...passThroughProps}>
      <ListItemText>{label}</ListItemText>
    </MenuItem>
  )
}

export const Dropdown = Object.assign(Root, {
  Option
})
